module.exports = __webpack_public_path__ + "static/media/Global Reporting Standard.8a740e9f.svg";